import React, { useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getResetPassword } from "../../../service/AuthenticationService";

const ResetPassword = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [token, setToken] = useState(queryParams.get("token"));
  // const token = localStorage.getItem("gs3_AuthToken");
  const { logo } = props;
  const [showpassword, setShowPassword] = useState(false);
  const [showConfirmpassword, setShowConfirmPassword] = useState(false);

//  console.log(token, "tokkeenn");

  const formik = useFormik({
    initialValues: {
      // name: '',
      password: "",
      confirmpassword: "",
    },
    validationSchema: yup.object({
      // name: yup.string().min(2, "name must have atleast 2 chracter").required(),
      password: yup
        .string()
        .min(8, "password must have atleast 8 chracter")
        .required(),
      confirmpassword: yup.string().min(8, "password must match").required(),
    }),
    onSubmit: async (values) => {
      // console.log(values);
      await getResetPassword(values.confirmpassword, token, (res) => {
      //  console.log(res);
        if (res.success === true) {
          toast.success(res.message);

          navigate("/");
          formik.resetForm();
        } else {
          toast.error(res.message);
          ////  console.log(res);
        }
      });
    },
  });

  console.error(formik.errors);

  const renderPasswordError = formik.touched.password &&
    formik.errors.password && (
      <span className="errorTxt">{formik.errors.password}</span>
    );

  const renderConfirmPasswordError = formik.touched.password &&
    formik.errors.password && (
      <span className="errorTxt">{formik.errors.password}</span>
    );

  // FOR-GET-LOGIN-RESPONSE
  const url = "https://reqres.in/api/users";

  const login = async (data) => {
    const response = await axios.post(url, data);
    // const getresponse =await axios.get(url)
    // console.log(getresponse, "getResponse")
    if ([200, 201, 202, 203, 204].includes(response.status)) {
      toast.success("Successfully");
    } else {
      toast.success("Error");
    //  console.log(response, "somnath");
    }
  };

  return (
    <>
      <div className="loginBg">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 centerResp">
              <span className="logo">
                <img src={logo} alt="" />
              </span>
              <h2>Welcome!</h2>
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="loginBase">
                <div className="text-center">
                  <h3>Reset Password</h3>
                  <h6 className="mb-5">
                    Enter your new password. (Enter minimum 8 characters)
                  </h6>
                </div>

                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-4">
                    <div className="showHide">
                      <input
                        className="form-control"
                        name="password"
                        type={showpassword ? "text" : "password"}
                        id="password"
                        placeholder="New Password"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                      />
                      <div
                        className="input-group-addon eyeAbs"
                        onClick={() => {
                          setShowPassword(!showpassword);
                        }}
                      >
                        <span>
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                      </div>
                      {renderPasswordError}
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="showHide">
                      <input
                        className="form-control"
                        name="confirmpassword"
                        type={showConfirmpassword ? "text" : "password"}
                        id="confirmpassword"
                        placeholder="Confirm Password"
                        onChange={formik.handleChange}
                        value={formik.values.confirmpassword}
                      />
                      <div
                        className="input-group-addon eyeAbs"
                        onClick={() => {
                          setShowConfirmPassword(!showConfirmpassword);
                        }}
                      >
                        <span>
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                      </div>
                      {renderConfirmPasswordError}
                    </div>
                  </div>

                  <div className="loginBtn pt-3 mb-5">
                    <button type="submit" className="commonButton">
                      Change Password
                    </button>
                  </div>
                </form>

                {/* <h6>Don't have an account? <a href=''>Register</a></h6> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
